<style src="../assets/css/contact.css" scoped></style>

<template>
  <main class="container">
    <section class="hero">
      <h1>Contact</h1>
      <p class="lead">
        Une question, un partenariat, ou l’envie de rejoindre l’aventure ?
        Vous pouvez nous contacter directement par <span class="hl">email</span> ou par
        <span class="hl">téléphone</span>.
      </p>
    </section>

    <section class="contactGrid">
      <!-- EMAIL -->
      <div class="contactCard">
        <i class="fas fa-envelope icon"></i>
        <h2>Email</h2>
        <p>
          Pour toute demande générale, partenariat refuge ou sponsoring.
        </p>
        <a class="contactLink" href="mailto:lesrefuges.animalier@gmail.com">
          lesrefuges.animalier@gmail.com
        </a>
      </div>

      <!-- PHONE -->
      <div class="contactCard">
        <i class="fas fa-phone-alt icon"></i>
        <h2>Téléphone</h2>
        <p>
          Pour un échange rapide ou une prise de contact directe.
        </p>
        <a class="contactLink" href="tel:+33632188372">
          06 32 18 83 72
        </a>
      </div>
    </section>

    <section class="ctaStrip">
      <h3>Vous êtes un refuge ou un partenaire ?</h3>
      <p>
        Asso-Refuge propose des sites <span class="hl">100% gratuits</span> (hébergement inclus, sans publicité)
        pour les refuges partenaires, et des partenariats transparents pour les marques engagées.
      </p>
    </section>
  </main>
</template>
